@if (form && hasErrors()) {
  <div #errorContainer class="error-container">
    <ul class="list-disc list-inside text-red-500 text-sm space-y-1">
      @for(controlName of controlNames(); track $index) {
        @if (form.get(controlName); as control) {
          @if (controlName && control && control.invalid && control.touched && errorKeys(control).length > 0) {
            <li>
              @if (control.invalid && control.touched) {
                @for (errorKey of errorKeys(control); track $index) {
                  <span>
                    <strong>{{ humanize(controlName) }}:</strong>
                    {{ getMessage(errorKey, control.errors?.[errorKey]) }}
                  </span>
                }
              }
            </li>
          }
        }
      }
    </ul>
    {{ form.errors?.['duplicateColors'] }}
  </div>
}
